import { deleteChallenge } from '@actions/challenges/deleteChallenge';
import { RootState } from '@reducers/index';
import {
    getChallengesDeleteSuccess,
    getChallengesIsDeleting,
    getChallenge,
    getChallengesDeleteError,
} from '@selectors/challenges';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

const useDeleteChallenge = (id: number) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const challenge = useSelector((state: RootState) => getChallenge(state, id));

    const handleSubmit = useCallback(() => dispatch(deleteChallenge(id)), [dispatch, id]);

    const isDeleting = useSelector(getChallengesIsDeleting);
    const deleteError = useSelector(getChallengesDeleteError);
    const deleteSuccess = useSelector(getChallengesDeleteSuccess);
    const { deleteSuccess: prevDeleteSuccess } = usePrevious({ deleteSuccess });
    useEffect(() => {
        if (!prevDeleteSuccess && deleteSuccess) {
            history.goBack();
        }
    }, [deleteSuccess, prevDeleteSuccess, history]);

    return { challenge, handleSubmit, isDeleting, deleteError };
};

export default useDeleteChallenge;
